import type { ReactNode } from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { PRICING_CARD_CLASS_NAME, PRICING_CARD_COMPACT_CLASS_NAME, PRICING_CARD_HEADER_CLASS_NAME, PRICING_CARD_PRICE_CLASS_NAME, PRICING_CARD_TITLE_CLASS_NAME } from './pricingCardStyles';

export function PricingCard({ plan, onSelect, highlighted = false, children, compact = false }: {
  plan: 'free' | 'standard' | 'enterprise';
  onSelect: () => void;
  highlighted?: boolean;
  children: ReactNode;
  compact?: boolean;
}) {
  const desktopSurfaceIsClickable = useMediaQuery('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  return (
    <article
      data-plan={plan}
      className={`pricing-card-desktop-interactive ${compact ? PRICING_CARD_COMPACT_CLASS_NAME : PRICING_CARD_CLASS_NAME} ${compact ? 'rounded-2xl' : 'rounded-3xl'} border-2 ${highlighted ? 'border-[rgb(var(--theme-primary)/0.45)] bg-[rgb(var(--theme-primary)/0.04)] shadow-sm' : compact ? 'border-[rgb(var(--theme-border)/0.4)]' : 'border-transparent'}`}
      data-highlighted={highlighted || undefined}
      onClick={(event) => {
        const target = event.target;
        if (desktopSurfaceIsClickable && target instanceof Element && event.currentTarget.contains(target)
          && !target.closest('button, a, input, select, textarea, [role="button"], [role="link"]')) onSelect();
      }}
    >
      {children}
    </article>
  );
}

export function PricingCardHeader({ title, price, period, detail, compact = false, controls }: {
  title: string;
  price: ReactNode;
  period?: ReactNode;
  detail?: ReactNode;
  compact?: boolean;
  controls?: ReactNode;
}) {
  return (
    <header className={PRICING_CARD_HEADER_CLASS_NAME}>
      <h3 className={compact ? 'text-xl font-bold text-slate-50' : PRICING_CARD_TITLE_CLASS_NAME}>{title}</h3>
      {controls && <div className="mt-3 w-full">{controls}</div>}
      <div className={PRICING_CARD_PRICE_CLASS_NAME}>
        <div data-pricing-amount className={`flex w-full items-center justify-center ${compact ? 'min-h-9' : 'min-h-12 sm:min-h-[3.75rem]'}`}>{price}</div>
        <div className={`mt-2 w-full ${compact ? '' : 'md:min-h-12'} ${period || detail ? '' : compact ? 'hidden' : 'hidden md:block'}`} aria-hidden={period || detail ? undefined : true}>
          {period}{detail}
        </div>
      </div>
    </header>
  );
}
